import { render } from "./DefaultInfoCard.vue?vue&type=template&id=3a788065&scoped=true"
import script from "./DefaultInfoCard.vue?vue&type=script&lang=js"
export * from "./DefaultInfoCard.vue?vue&type=script&lang=js"

import "./DefaultInfoCard.vue?vue&type=style&index=0&id=3a788065&scoped=true&lang=css"

import exportComponent from "/var/www/html/fms_employee_Portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a788065"]])

export default __exports__